// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_2c8Rlsi","h5Text":"_2stZl3G","h4Text":"YJ1cd7Y","h3Text":"_2OGvViD","srOnly":"_1KrNB_W","link":"_36Mt56U _2c8Rlsi","block":"_2tsa3Tm","fakeOutsideBlock":"xGHs8oT"};